export const GET_USERS_LIST = "GET_USERS_LIST";
export const SET_USERS_LIST = "SET_USERS_LIST";
export const SET_ROLE_LIST = "SET_ROLE_LIST";
export const SET_USERS_ACTIVE_SCREEN ="SET_USERS_ACTIVE_SCREEN";
export const SET_CLOSE_EDIT_USER_MODAL = "SET_CLOSE_EDIT_USER_MODAL";
export const SET_OPEN_EDIT_USER_MODAL = "SET_OPEN_EDIT_USER_MODAL";
export const SET_IS_GET_USER_ROLE_LIST_PENDING = "SET_IS_GET_USER_ROLE_LIST_PENDING";
export const SET_IS_EDIT_ROLE_PENDING ="SET_IS_EDIT_ROLE_PENDING";